<template>
  <dialog-reset height="75vh" top="5vh" width="80%" title="选择计划" :visible.sync="visible">
    <avue-crud v-if="visible" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :permission="permissionList" :before-open="beforeOpen" v-model="form" ref="crud" @row-update="rowUpdate"
      @row-save="rowSave" @row-del="rowDel" @search-change="searchChange" @search-reset="searchReset" @selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange"
      @row-dblclick="rowDblClick" @on-load="onLoad">
      <template slot-scope="{ row }" slot="timeAndUser">
        <div>{{ row.updateName }}</div>
        <div>{{ row.updateTime }}</div>
      </template>
    </avue-crud>
  </dialog-reset>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getCheckList } from "../api";
// import { getSearchTimeConfig, rulesInput } from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  name: 'SelectContract',
  data () {
    const that = this
    return {
      apiConfig: { getList: getCheckList },
      defaultParams: {
         planStatus: "1",
      },
      visible: false,
      query: {},
      option: {
        cancelHijack: true,
        maxHeight: '380',
        searchShow: true,
        searchSpan: 6,
        searchMenuSpan: 24,
        searchMenuPosition: 'right',
        menu: false,
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: true,
        dialogClickModal: false,
        searchLabelWidth: 90,
        indexLabel: '序号',
        align: 'center',
        labelWidth: 135,
        column: [
          {
            label: "计划编号",
            prop: "planCode",
            overHidden: true,
            search: true,
            searchLabelWidth: 100,
            searchSpan: 6,
            searchPlaceholder: "请输入计划编号",
            slot: true,
            width: 200,
          },
          {
            label: "计划名称",
            prop: "planName",
            overHidden: true,
            search: true,
            searchLabelWidth: 100,
            searchSpan: 6,
            searchPlaceholder: "请输入计划名称",
            minwidth: 200,
          },
          {
            label: "检查类型",
            prop: "checkType",
            type: "select",
            search: true,
            hide: false,
            showColumn: true,
            dicUrl: "/api/produce/safey-type/select/querySafeyType?safeyType=1",
            props: {
              label: "typeName",
              value: "typeCode",
            },
            width: 100,
          },
          {
            label: "责任部门",
            prop: "responsibleDeptName",
            overHidden: true,
            search: false,
            searchSpan: 6,
            searchLabelWidth: 100,
            searchPlaceholder: "请输入责任部门",
            width: 200,
          },
          {
            label: "负责人",
            prop: "responsiblePersonId", // 查询时使用的 key
            type: "select",
            search: true,
            hide: true, // 在表格中隐藏，仅作为搜索控件存在
            searchSpan: 6,
            searchLabelWidth: 100,
            searchPlaceholder: "请选择负责人",
            remote: true,
            filterable: true,
            dicUrl: "/api/produce/blade-user/select/userList",
            props: { label: "name", value: "id" },
          },
          {
            label: "负责人",
            prop: "responsiblePersonName", // 表格展示字段
            overHidden: true,
            search: false, // 不再作为查询字段
            searchSpan: 6,
            searchLabelWidth: 100,
            searchPlaceholder: "请输入负责人",
            width: 100,
          },
          {
            label: "执行频率",
            prop: "checkFrequency",
            type: "select",
            overHidden: true,
            search: true,
            searchSpan: 6,
            searchLabelWidth: 100,
            dataType: "number",
            dicData: [
              { label: "全部频率", value: "" },
              { label: "每日", value: 0 },
              { label: "每周", value: 1 },
              { label: "每月", value: 2 },
            ],
            slot: true,
            width: 100,
          },
          {
            label: "最近检查时间",
            prop: "lastCheckTime",
            type: "datetime",
            overHidden: true,
            search: false,
            slot: true,
            width: 100,
          },
          {
            label: "下次检查日期",
            prop: "nextCheckDate",
            type: "datetime",
            overHidden: true,
            search: false,
            slot: true,
            width: 100,
          },
          {
            label: "状态",
            prop: "planStatus",
            type: "select",
            overHidden: true,
            dataType: "number",
            dicData: [
              { label: "禁用", value: 0 },
              { label: "启用", value: 1 },
            ],
            slot: true,
            width: 100,
          },
        ],
      },
    }
  },
  created () { },
  methods: {
    open () {
      this.visible = true
    },
    //  提交
    rowDblClick (item) {
      //  带出通知
      this.$emit('replace', item,)
      this.visible = false
    },

  },
}
</script>
<style lang="scss" scoped>
::v-deep .avue-crud__menu {
  display: none;
}
</style>

